import { ServiceAppointment as Appointment } from '@quorum/models/xs-resource';
import { ServiceAppointmentQueryParameters as AppointmentQueryParameters } from '@quorum/models/xs-query';
import { Action } from '@ngrx/store';

export enum AppointmentsEntityActionTypes {
  GetAppointmentsFromServer = '[Fixed Operations] Get Appointments From Server',
  GetAppointmentsFromServerError = '[Fixed Operations] Get Appointments From Server Error',
  GetAppointmentsFromServerSuccess = '[Fixed Operations] Get Appointments From Server Success',
  UpdateAppointmentOnServer = '[Fixed Operations] Update Appointment On Server',
  UpdateAppointmentOnServerError = '[Fixed Operations] Update Appointment On Server Error',
  UpdateAppointmentOnServerSuccess = '[Fixed Operations] Update Appointment On Server Success',
  CreateAppointmentOnServer = '[Fixed Operations] Create Appointment From Server',
  CreateAppointmentOnServerError = '[Fixed Operations] Create Appointment From Server Error',
  CreateAppointmentOnServerSuccess = '[Fixed Operations] Create Appointment From Server Success',
  DeleteAppointmentFromServer = '[Fixed Operations] Delete Appointment From Server',
  DeleteAppointmentFromServerError = '[Fixed Operations] Delete Appointment From Server Error',
  DeleteAppointmentFromServerSuccess = '[Fixed Operations] Delete Appointment From Server Success'
}

//#region message-types
export class GetAppointmentsFromServer implements Action {
  readonly type = AppointmentsEntityActionTypes.GetAppointmentsFromServer;
  constructor(public payload: { params: AppointmentQueryParameters; returnAction: any }) {}
}
export class GetAppointmentsFromServerError implements Action {
  readonly type = AppointmentsEntityActionTypes.GetAppointmentsFromServerError;
  constructor(public payload: any) {}
}
export class GetAppointmentsFromServerSuccess implements Action {
  readonly type = AppointmentsEntityActionTypes.GetAppointmentsFromServerSuccess;
  constructor(public payload: Appointment[]) {}
}

export class UpdateAppointmentOnServer implements Action {
  readonly type = AppointmentsEntityActionTypes.UpdateAppointmentOnServer;
  constructor(public payload: { appointment: Appointment; appointmentQueryParams: AppointmentQueryParameters }) {}
}

export interface UpdateAppointmentOnServerErrorPayload {
  appointment: Appointment;
  error: unknown;
}

export class UpdateAppointmentOnServerError implements Action {
  readonly type = AppointmentsEntityActionTypes.UpdateAppointmentOnServerError;
  constructor(public payload: UpdateAppointmentOnServerErrorPayload) {}
}
export class UpdateAppointmentOnServerSuccess implements Action {
  readonly type = AppointmentsEntityActionTypes.UpdateAppointmentOnServerSuccess;
  constructor(public payload: Appointment) {}
}

export class CreateAppointmentOnServer implements Action {
  readonly type = AppointmentsEntityActionTypes.CreateAppointmentOnServer;
  constructor(public payload: { appointment: Appointment; appointmentQueryParams: AppointmentQueryParameters }) {}
}
export class CreateAppointmentOnServerError implements Action {
  readonly type = AppointmentsEntityActionTypes.CreateAppointmentOnServerError;
  constructor(public payload: any) {}
}
export class CreateAppointmentOnServerSuccess implements Action {
  readonly type = AppointmentsEntityActionTypes.CreateAppointmentOnServerSuccess;
  constructor(public payload: Appointment) {}
}

export class DeleteAppointmentFromServer implements Action {
  readonly type = AppointmentsEntityActionTypes.DeleteAppointmentFromServer;
  constructor(public payload: { appointment: Appointment }) {}
}
export class DeleteAppointmentFromServerError implements Action {
  readonly type = AppointmentsEntityActionTypes.DeleteAppointmentFromServerError;
  constructor(public payload: any) {}
}
export class DeleteAppointmentFromServerSuccess implements Action {
  readonly type = AppointmentsEntityActionTypes.DeleteAppointmentFromServerSuccess;
  constructor(public payload: { appointment: Appointment }) {}
}
//#endregion

export type AppointmentsEntityAction =
  | GetAppointmentsFromServer
  | GetAppointmentsFromServerError
  | GetAppointmentsFromServerSuccess
  | UpdateAppointmentOnServer
  | UpdateAppointmentOnServerError
  | UpdateAppointmentOnServerSuccess
  | CreateAppointmentOnServer
  | CreateAppointmentOnServerError
  | CreateAppointmentOnServerSuccess
  | DeleteAppointmentFromServer
  | DeleteAppointmentFromServerError
  | DeleteAppointmentFromServerSuccess;

export const fromAppointmentsEntityActions = {
  GetAppointmentsFromServer,
  GetAppointmentsFromServerError,
  GetAppointmentsFromServerSuccess,
  UpdateAppointmentOnServer,
  UpdateAppointmentOnServerError,
  UpdateAppointmentOnServerSuccess,
  CreateAppointmentOnServer,
  CreateAppointmentOnServerError,
  CreateAppointmentOnServerSuccess,
  DeleteAppointmentFromServer,
  DeleteAppointmentFromServerError,
  DeleteAppointmentFromServerSuccess
};
